import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { USER_CONFIG, USER_CONSTANTS } from './user.config';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserEffects } from './effects/user.effects';
import userReducer, { name as userFeatureName } from './features/user.slice';
import { AboutMeFormComponent } from './components/about-me-form/about-me-form.component';
import { BasicInformationFormComponent } from './components/basic-information-form/basic-information-form.component';
import { CaptiveFormWrapperComponent } from './components/captive-form-wrapper/captive-form-wrapper.component';
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';
import { ManagerAccountComponent } from './components/manager-account/manager-account.component';
import { MyDeviceFormComponent } from './components/my-device-form/my-device-form.component';
import { ProblemWithSerialErrorComponent } from './components/my-device-form/components/problem-with-serial-error/problem-with-serial-error.component';
import { MyIntererstsFormComponent } from './components/my-interersts-form/my-interersts-form.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { SharedModule } from '@shared/shared.module';
import { AboutMeEffects } from './effects/about-me.effects';
import { InterestsEffects } from './effects/interests.effects';
import { DevicesEffects } from './effects/devices.effects';
import { AccountManagerEffects } from './effects/account-manager.effects';
import { SharedDeviceControlComponent } from './components/my-device-form/components/shared-device-control/shared-device-control.component';
import { RegisteredDeviceComponent } from './components/my-device-form/components/registered-device/registered-device.component';
import { NewDeviceComponent } from './components/my-device-form/components/new-device/new-device.component';
import { SharedDeviceHintComponent } from './components/my-device-form/components/shared-device-hint/shared-device-hint.component';

@NgModule({
  declarations: [
    AboutMeFormComponent,
    BasicInformationFormComponent,
    CaptiveFormWrapperComponent,
    ChangePasswordFormComponent,
    ManagerAccountComponent,
    MyDeviceFormComponent,
    ProblemWithSerialErrorComponent,
    MyIntererstsFormComponent,
    StepperComponent,
    SharedDeviceControlComponent,
    RegisteredDeviceComponent,
    NewDeviceComponent,
    SharedDeviceHintComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(userFeatureName, userReducer),
    EffectsModule.forFeature([
      UserEffects,
      InterestsEffects,
      AboutMeEffects,
      DevicesEffects,
      AccountManagerEffects
    ])
  ],
  providers: [{ provide: USER_CONFIG, useValue: USER_CONSTANTS }],
  exports: [
    AboutMeFormComponent,
    BasicInformationFormComponent,
    CaptiveFormWrapperComponent,
    ChangePasswordFormComponent,
    ManagerAccountComponent,
    MyDeviceFormComponent,
    MyIntererstsFormComponent,
    StepperComponent,
    SharedModule
  ]
})
export class UserModule {}
